import type { AlertAudience, AlertCategory, AuditType } from "@/services/api/guardiansv2/types";

export type AlertCategoryFilter = AlertCategory | "all";
export type AlertAudienceFilter = AlertAudience | "all";

export interface GuardiansFilterValues {
  auditType: AuditType | "all";
  missionTemplateId: string;
  taskId: string;
  agentId: string;
  catalogueId: string;
  alertCategory: AlertCategoryFilter;
  alertAudience: AlertAudienceFilter;
}

export const DEFAULT_GUARDIANS_FILTERS: GuardiansFilterValues = {
  auditType: "all",
  missionTemplateId: "",
  taskId: "",
  agentId: "",
  catalogueId: "",
  alertCategory: "all",
  alertAudience: "all",
};

export type SecondaryFilterKey =
  | "missionTemplateId"
  | "taskId"
  | "agentId"
  | "catalogueId"
  | "alertCategory"
  | "alertAudience"
  | "auditType";

export function clearSecondaryFilter(
  values: GuardiansFilterValues,
  key: SecondaryFilterKey
): GuardiansFilterValues {
  if (key === "alertCategory") return { ...values, alertCategory: "all" };
  if (key === "alertAudience") return { ...values, alertAudience: "all" };
  if (key === "auditType") return { ...values, auditType: "all" };
  return { ...values, [key]: "" };
}

export function guardiansSecondaryFilterCount(values: GuardiansFilterValues): number {
  let n = 0;
  if (values.missionTemplateId) n++;
  if (values.taskId) n++;
  if (values.agentId) n++;
  if (values.catalogueId) n++;
  if (values.alertCategory !== "all") n++;
  if (values.alertAudience !== "all") n++;
  return n;
}
